<template>
  <div class="brand">
    <div :class="{cur_pointer:adLinkUrl,banner:true}" :style="{ backgroundImage: 'url( ' + banner + ')'}" @click="themeLink(adLinkUrl)"></div>
    <div ref="refScroll" class="com_title container1">品牌中心</div>
    <div class="en_title container1">BRAND CENTER</div>
    <div class="list container1">
      <div class="item" v-for="(v,i) in list" :key="i">
        <div class="left"><img v-lazy="v.publicizeFilePath"></div>
        <div class="right">
          <div class="logo">
            <img class="img" v-lazy="v.logoFilePath">
            <div class="name">{{v.name}}</div>
          </div>
          <div class="title1">{{v.title}}</div>
          <div class="title2">{{v.manifesto}}</div>
          <p class="content com_hidden3">{{v.introduction}}</p>
          <el-button type="info" class="btn" @click="linkDetail(v.serNo)">
            <span class="text">进入品牌</span>
            <i class="el-icon-right"></i>
          </el-button>
        </div>
      </div>
    </div>
    <no-auth ref="noAuth"></no-auth>
    <el-pagination class="pagination container1" background @current-change="handleCurrentChange" :current-page="pageInfo.pageNumber" :page-size="pageInfo.pageSize" layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
  </div>
</template>

<script>
import { GetAdPositionId, GetBrandList } from "@/pages/page1/api/modules/home";
import NoAuth from "@/components/noAuth";
export default {
  metaInfo: { title: "品牌馆 - 多比商城" },
  components: {
    NoAuth,
  },
  data() {
    return {
      banner: "",
      adLinkUrl: "",
      img1: require("@/assets/img/brandLogo1.jpg"),
      img2: require("@/assets/img/brandLogo2.jpg"),
      total: 100,
      pageInfo: {
        pageNumber: 1,
        pageSize: 6,
        searchProperty: [],
        orderProperty: [],
      },
      list: [],
    };
  },
  mounted() {
    if (this.$store.getters.userTypeA) {
      this.pageInfo.pageNumber = this.$route.query.page || 1;
      this.pageInfo.pageNumber = parseInt(this.pageInfo.pageNumber);
      let adPositionId = this.$configId.adPositionId;
      this.getBanner(adPositionId.brandPavilion);
      this.getBrandList();
    } else {
      this.$refs.noAuth.open();
    }
  },
  methods: {
    getBrandList() {
      GetBrandList({ pageInfo: this.pageInfo }).then((res) => {
        this.list = res.data;
        this.total = res.count;
        if (this.pageInfo.pageNumber > 1) {
          this.scrollInto("refScroll");
        }
      });
    },
    getBanner(id) {
      let params = {
        adPositionId: id,
        themeCount: 1,
        contentCount: 0,
        loadNoConTheme: 1, //不过滤没有内容的主题
      };
      GetAdPositionId(params).then((res) => {
        // console.log("当前页banner", res);
        try {
          this.banner = res.data[0].themeFileUrl;
          this.adLinkUrl = res.data[0].adLinkUrl;
        } catch (error) {}
      });
    },
    linkDetail(serNO) {
      let newUrl = this.$router.resolve({
        path: "brandCategory",
        query: { brandSerNos: serNO },
      });
      window.open(newUrl.href, "_blank");
    },
    // 分页
    handleCurrentChange(val) {
      this.pageInfo.pageNumber = val;
      let newUrl = this.$router.resolve({
        path: "brandList",
        query: { page: val === 1 ? undefined : val },
      });
      window.open(newUrl.href, "_self");
    },
    // 主题位置跳转
    themeLink(url) {
      if (!url) {
        return false;
      }
      if (url.indexOf("http") == -1) {
        url = "http://" + url;
      }
      window.open(url, "_blank");
    },
    scrollInto(refName) {
      let element = this.$refs[refName];
      element.scrollIntoView(); //页面完全加载才滚动
    },
  },
};
</script>

<style lang="less" scoped>
.brand {
  background-color: #f1f1f1;
  color: #333333;
  line-height: 1;
  padding-bottom: 100px;
  .banner {
    height: 546px;
    width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .com_title {
    font-size: 30px;
    font-weight: bold;
    text-align: center;
    margin-top: 82px;
  }
  .en_title {
    font-size: 16px;
    font-weight: 300;
    text-align: center;
    opacity: 0.7;
    margin-top: 18px;
  }
  .list {
    padding: 38px 0 50px;
    background-color: #f1f1f1;
    .item {
      width: 100%;
      height: 348px;
      background: #ffffff;
      margin-bottom: 24px;
      display: flex;
      .left {
        width: 50%;
        height: 100%;
      }
      .right {
        width: 50%;
        height: 100%;
        box-sizing: border-box;
        padding: 0 40px 0 50px;
        position: relative;
        .logo {
          height: 107px;
          box-sizing: border-box;
          border-bottom: 1px dashed #333333;
          display: flex;
          align-items: center;
          .img {
            display: block;
            width: auto;
            height: auto;
            max-width: 300px;
            max-height: 84px; //ie 百分比带小数时页面会出现错乱
          }
          .name {
            margin-left: 48px;
            padding-left: 48px;
            border-left: 2px solid #333333;
            font-size: 24px;
          }
        }
        .title1 {
          margin-top: 9px;
          font-size: 18px;
          line-height: 36px;
          height: 36px;
        }
        .title2 {
          font-size: 16px;
          line-height: 34px;
          height: 34px;
        }
        .content {
          font-size: 12px;
          line-height: 24px;
          height: 72px;
        }
        .btn {
          position: absolute;
          bottom: 16px;
          right: 40px;
          width: 148px;
          height: 40px;
          box-sizing: border-box;
          padding: 0;
          background-color: #ffffff;
          border: 1px solid #333333;
          border-radius: 20px;

          font-size: 16px;
          color: #333333;
          &:hover {
            background-color: @themeColor;
            color: #ffffff;
            border-color: @themeColor;
            outline: 0;
          }
          &:active {
            color: #e6a315;
            border-color: #e6a315;
            outline: 0;
          }
          .text {
            padding-right: 20px;
          }
          i {
            font-size: 20px;
          }
        }
      }
      &:last-child {
        margin-bottom: 0;
      }
      &:hover {
        box-shadow: 0px 12px 21px 0px rgba(4, 0, 0, 0.23);
      }
    }
  }
  .pagination {
    text-align: right;
  }
}
</style>